<template>
  <span :class="badgeClass">{{ displayText }}</span>
</template>

<script>
const REASON_CONFIG = {
  split: { class: "badge badge-success", label: "Split" },
  "sole recipient": { class: "badge badge-success", label: "Sole" },
  remainder: { class: "badge badge-info", label: "Rounding" },
  "account manager split": { class: "badge badge-primary", label: "AM Split" },
  "account manager remainder": {
    class: "badge badge-primary",
    label: "AM Rounding",
  },
  unmatched: { class: "badge badge-warning", label: "Unmatched" },
  matched: { class: "badge badge-success", label: "Matched" },
};

const DEFAULT_CONFIG = { class: "badge badge-secondary", label: null };

export default {
  name: "ReasonBadge",
  props: {
    // The reason/status value
    reason: {
      type: String,
      default: "",
    },
  },
  computed: {
    normalizedReason() {
      return this.reason?.toLowerCase() || "";
    },
    config() {
      return REASON_CONFIG[this.normalizedReason] || DEFAULT_CONFIG;
    },
    badgeClass() {
      return this.config.class;
    },
    displayText() {
      return this.config.label || this.reason || "—";
    },
  },
};
</script>
